import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const RmrInventoryItem_ = z.object({
  productId: z.string(),
  productName: z.string(),
  sku: z.string().nullable(),
  sourceId: z.string().nullable(),
  locationId: z.string(),
  locationName: z.string(),
  priceCents: z.number().nullable(),
  quantity: z.number(),
  committed: z.number(),
  available: z.number(),
});
export const RmrInventoryItem: z.ZodType<RmrInventoryItem> = RmrInventoryItem_;
export interface RmrInventoryItem extends z.infer<typeof RmrInventoryItem_> {}

export const getRmrMerchantInventory = unaryRpc({
  name: "getRmrMerchantInventory" as const,
  input: z.object({
    teamId: z.string(),
    page: z.number().min(0).optional(),
    pageSize: z.number().min(1).max(500).default(50),
    search: z.string().optional(),
  }),
  output: z.object({
    items: z.array(RmrInventoryItem),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});
